import { WebshopProduct } from '@cldsystems/ws-api-client';
import { ERRORS } from '@/constants/error';
import { useAppContext } from '@/providers/app-provider/app-provider';
import { List } from '@/types/common';

export const useAllProductsByLocaleContext = () => {
  const context = useAppContext<{ allProductsByLocale: List<WebshopProduct> }>();
  if (!context.allProductsByLocale) {
    throw ERRORS.REGULAR('allProductsByLocale must be passed to <Page/> context');
  }
  return context.allProductsByLocale;
};
